import { consts } from "../common/modals/consts";
import { ICompanyJobTitle } from "./company-job-title.interface";
import { ElectricalWorkType } from "./electrical-work-type";

export class CompanyJobTitle implements ICompanyJobTitle {
  name: string;
  defaultJobLevelId: string;
  defaultJobLevelName?: string;
  electricalWorkType?: ElectricalWorkType;
  operativeTypeId: string;
  createdBy: string;
  updatedBy: string;
  isSelected: boolean;
  id: string;
  description: string;
  companyId: string;


  constructor(iCompanyJobTitle: ICompanyJobTitle = null) {
    this.id = iCompanyJobTitle?.id || consts.emptyGuid;
    this.name = iCompanyJobTitle?.name || "";
    this.description = iCompanyJobTitle?.description || "";
    this.isSelected = iCompanyJobTitle?.isSelected || false;
    this.companyId = iCompanyJobTitle?.companyId || consts.emptyGuid;
  }

  get isValid(): boolean {
    return !!this.name;
  }

}
